module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "inspection-tab-white"
  }, [_c('div', {
    attrs: {
      "id": "inspection-internal"
    }
  }, _vm._l((_vm.inspection_internals), function(inspection_internal) {
    return _c('div', {
      staticClass: "row internal-elements"
    }, [_c('div', {
      staticClass: "col-lg-6"
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(inspection_internal.element.section.name) + " - " + _vm._s(inspection_internal.element.name))]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "image-points"
    }, [_c('img', {
      staticClass: "chair",
      attrs: {
        "src": ("" + (inspection_internal.element.image_path))
      }
    }), _vm._v(" "), _vm._l((inspection_internal.points), function(point) {
      return _c('div', {
        staticClass: "internal-point",
        style: (("left: " + (point.x) + "px;top: " + (point.y) + "px"))
      }, [_vm._v("\n                                " + _vm._s(point.order) + "\n                            ")])
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 internal-element-data"
    }, [(inspection_internal.photo.url != null) ? _c('div', {
      staticClass: "title-photo"
    }, [_c('h3', [_vm._v("Общая фотография секции - " + _vm._s(inspection_internal.element.section.name))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          inspection_internal.photo.display = !inspection_internal.photo.display
        }
      }
    }, [_vm._v("Смотреть фото")]), _vm._v(" "), (inspection_internal.photo.display) ? _c('div', {
      staticClass: "inspection-photo"
    }, [_c('a', {
      attrs: {
        "href": inspection_internal.photo.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": inspection_internal.photo.url
      }
    })])]) : _vm._e()]) : _c('div', {
      staticClass: "row"
    }), _vm._v(" "), _c('div', {
      staticClass: "internal-element-data-table"
    }, [_c('h3', [_vm._v("Повреждения")]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((inspection_internal.points), function(point) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(point.order))]), _vm._v(" "), _c('td', _vm._l((point.damages), function(damage) {
        return _c('div', [_vm._v("\n                                        " + _vm._s(damage.name) + "\n                                    ")])
      })), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-sm btn-edit",
        on: {
          "click": function($event) {
            point.photo.display = !point.photo.display
          }
        }
      }, [_vm._v("Смотреть фото")]), _vm._v(" "), (point.photo.display) ? _c('div', {
        staticClass: "inspection-photo"
      }, [_c('a', {
        attrs: {
          "href": point.photo.url,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": point.photo.url
        }
      })])]) : _vm._e()])])
    }))])])])])
  }))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d70e251a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d70e251a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionInternal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d70e251a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionInternal.vue
// module chunks = 0